export const dateMatchLevels = {
  DAY: 'DAY',
  YEAR: 'YEAR',
};
